module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-card col-xs-4 col-sm-4 col-md-3 col-lg-2 col-xl-1 w100"
  }, [_c('pl-card', {
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.goToEditPremade(_vm.premade.type)
      }
    }
  }, [_c('div', {
    staticClass: "inner-card"
  }, [_c('section', {
    staticClass: "rt-type-container"
  }, [(_vm.premade.type === 'live') ? _c('div', {
    staticClass: "row middle-xs center-xs live-rt"
  }, [_c('img', {
    attrs: {
      "width": "26px",
      "height": "24px",
      "src": "static/logos/live.svg"
    }
  }), _vm._v(" "), _c('span', [_vm._v(" Verbal ")])]) : (_vm.premade.type === 'online') ? _c('div', {
    staticClass: "row middle-xs center-xs online-rt"
  }, [_c('img', {
    attrs: {
      "width": "26px",
      "height": "24px",
      "src": "static/logos/online.svg"
    }
  }), _vm._v(" "), _c('span', [_vm._v(" Written ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row center-xs middle-xs card-image-container"
  }, [_c('pl-preloader', {
    staticClass: "card-image",
    attrs: {
      "src": _vm.get_thumbnail_on_amazon_aws
    }
  }), _vm._v(" "), (_vm.premade.is_certified) ? _c('div', {
    staticClass: "row center-xs middle-xs parlay-certified"
  }, [_c('img', {
    attrs: {
      "src": "static/logos/universe_logo.svg"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.getProfile.role === 'admin') ? [(_vm.premade.accessibility !== 'Public') ? _c('div', {
    staticClass: "publish-status",
    class: {
      draft: _vm.premade_accessibility
    }
  }, [_c('span', {
    staticClass: "pl-subheading",
    staticStyle: {
      "font-size": "20px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.premade.accessibility))])]) : _vm._e()] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "pl-subheading row",
    staticStyle: {
      "position": "relative",
      "min-height": "48px"
    }
  }, [_c('strong', {
    staticClass: "col-xs-12 ellipsisTitle"
  }, [_vm._v(_vm._s(_vm.premade.title))])]), _vm._v(" "), _c('div', {
    staticClass: "pl-subheading row col-xs-12 ellipsisSubjectGrade",
    on: {
      "mouseover": function($event) {
        _vm.activeTooltipSubject = true
      },
      "mouseout": function($event) {
        _vm.activeTooltipSubject = false
      }
    }
  }, [(_vm.activeTooltipSubject) ? _c('div', {
    staticClass: "activeTooltip"
  }, _vm._l((_vm.premade.subjects), function(subject) {
    return _c('p', {
      key: subject.id
    }, [_vm._v("\n            " + _vm._s(subject.name) + "\n          ")])
  }), 0) : _vm._e(), _vm._v(" "), _vm._l((_vm.premade.subjects), function(subject, i) {
    return [_vm._v("\n          " + _vm._s(subject.name) + _vm._s(i === _vm.premade.subjects.length - 1 ? '' : ',') + "\n        ")]
  })], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "24px"
    }
  }, [(_vm.premade.grade_levels.length > 0) ? _c('div', {
    staticClass: "pl-subheading row col-xs-12 ellipsisSubjectGrade",
    on: {
      "mouseover": function($event) {
        _vm.activeTooltipGrade = true
      },
      "mouseout": function($event) {
        _vm.activeTooltipGrade = false
      }
    }
  }, [(_vm.activeTooltipGrade) ? _c('div', {
    staticClass: "activeTooltip"
  }, _vm._l((_vm.premade.grade_levels), function(level) {
    return _c('p', {
      key: level.id
    }, [_vm._v("\n              " + _vm._s(level.grade) + "\n            ")])
  }), 0) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "subject_grade_span",
    staticStyle: {
      "float": "left",
      "margin-right": "2px"
    }
  }, [_vm._v("\n            Grades:")]), _vm._v(" "), _vm._l((_vm.sortGrades), function(level, i) {
    return [_vm._v("\n            " + _vm._s(level) + _vm._s(i === _vm.sortGrades.length - 1 ? '' : ',') + "\n          ")]
  })], 2) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "pl-subheading row col-xs-12",
    staticStyle: {
      "margin": "0",
      "border-top": "1px solid #808284"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row col-xs-12 author-info"
  }, [_c('div', {
    staticClass: "col-xs-9 authorName"
  }, [_c('img', {
    attrs: {
      "src": _vm.premade_author.avatar_url
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.premade_author.name))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3 ml-auto",
    staticStyle: {
      "padding": "0",
      "text-align": "right"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "15px",
      "align-self": "center"
    },
    attrs: {
      "src": "/static/replications_icon.svg"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#797979",
      "font-weight": "normal"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.formatNumber(_vm.premade.replications)) + "\n          ")])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-03da62b9!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/onlineRoundtables/components/searchEditPremadeCard/searchEditPremadeCard.vue
// module id = 2007
// module chunks = 61